import ModelEntity from "../model-entity";
import {EntityType} from "../../gd/const/item";
import ModelProxy from "../model-proxy";
import ApiTemplate from "../../gd/api/template";
import {TemplateAccess, TemplateType} from "./@const";
import {DashboardType} from "../../gd-modules/dashboard/model/dashboard/types";
import TemplateAccessControl from "./access-control/access-control";

const debug = "Template"
// const debug = false

export default class Template extends ModelEntity {


    // public id               : ID
    public publicId         : ID
    public createdByUserId  : ID
    public name             : string
    public description      : string
    public access           : TemplateAccess
    public type             : TemplateType
    public data?            : any // olways undefiend in session - needed whe creating template
    // public metadata         : any // lazy loading needed
    // public isDeleted        : boolean // don't need on a client ?
    // public momentCreated    : Moment
    // public momentUpdated    : Moment


    constructor(data: any, useProxy = true) {

        super(data['id'], EntityType.TEMPLATE);

        // this.id             = data['id']
        this.publicId       = data['publicId']
        this.createdByUserId= data['createdByUserId']
        this.name           = data['name']
        this.description    = data['description']
        this.access         = data['access']
        this.type           = data['type']
        this.data           = data['data']
        // this.momentCreated  = data['momentCreated']
        // this.momentUpdated  = data['momentUpdated']
        // this.isDeleted      = data['isDeleted']

        return useProxy ? new Proxy(this, ModelProxy) : this;

    }


    get isProjectDashboard():boolean {
        return this.type === TemplateType.DASHBOARD_PROJECT
    }

    get isCustomDashboard():boolean {
        return this.type === TemplateType.DASHBOARD_CUSTOM
    }
    // No id = new ver saved = new model
    get isNewModel():boolean {
        return !this.id
    }

    get dashboardType(): DashboardType {
        switch (this.type) {
            case TemplateType.DASHBOARD_PROJECT:
                return DashboardType.PROJECT
            case TemplateType.DASHBOARD_CUSTOM:
                return DashboardType.CUSTOM
            case TemplateType.DASHBOARD_USER:
                return DashboardType.USER
            default:
                console.error("#sfr34d This is not dashboard template")
                throw new Error("#sfr34d This is not dashboard template")
        }
    }

    get preview(): string {
        switch (this.type) {
            case TemplateType.DASHBOARD_PROJECT:
                return "project-templates.svg"
            case TemplateType.DASHBOARD_CUSTOM:
                return "custom-templates.svg"
            case TemplateType.DASHBOARD_USER:
                return "user-templates.svg"
            default:
                console.error("#sfr34d This is not dashboard template")
                throw new Error("#sfr34d This is not dashboard template")
        }
    }

    get acl():TemplateAccessControl {
        return new TemplateAccessControl(this)
    }


    async save():Promise<boolean> {

        const payload: any = {}

        debug && console.log(debug,"save", this.updatedFields);

        // if new model -> create instead of save
        if (this.isNewModel) {
            await ApiTemplate.create(this.toJSON()).promise()
            return true
        }

        // Update
        // this is for universal update
        this.updatedFields.forEach((fieldName) => {
            switch (fieldName) {


                default                 :
                    // @ts-ignore
                    payload[fieldName] = this[fieldName]
            }
        })

        this.updatedFields.clear()

        if (_.size(payload)>0) {
            await ApiTemplate.update(this.id, payload).promise()
            return true
        }

        return false
    }

    toOption():Option {
        return {
            label       : this.name,
            value       : this.id
        }
    }

    // validate():ErrorProto[] | null  {
    //     const errors : any[] = []
    //
    //     if (!this.name) errors.push(new ErrorFieldRequired(gd.fields.office.name))
    //
    //     if (_.isEmpty(errors)) return null
    //     else return errors
    // }

    toJSON() {
        return {
            id              : this.id,
            publicId        : this.publicId,
            createdByUserId : this.createdByUserId,
            name            : this.name,
            description     : this.description,
            access          : this.access,
            type            : this.type,
            // momentCreated   : DatetimeUtils.momentToUTCISODatetime(this.momentCreated),
            // momentUpdated   : DatetimeUtils.momentToUTCISODatetime(this.momentUpdated),
            // isDeleted       : this.isDeleted,
            // metadata        : this.metadata,
            data            : this.data

        }
    }

}
